(() => {
  // ✅ Shopify Inbox: EMBED ON (recommended)
  // - Theme → Customize → App embeds → Shopify Inbox = ON
  // - NO script loading, NO scaffolding
  // - Hide host visually by default (no layout jumps)
  // - Open chat from your "Need help?" notch instantly
  (() => {
    const STYLE_ID = 'rx-inbox-hard-hide';
    const SOFT_ID  = 'rx-inbox-soft-open'; // ✅ FIX: soft-open override to prevent flicker
    const SEL_HOST = 'inbox-online-store-chat#ShopifyChat';
    const SEL_CONTAINER = '#shopify-chat';

    const log = (...a) => console.log('[RX Inbox]', ...a);

    const getHost = () =>
      document.querySelector(SEL_HOST) ||
      document.querySelector(`${SEL_CONTAINER} ${SEL_HOST}`) ||
      document.querySelector('inbox-online-store-chat');

    // ✅ Hide only the host (no display:none, no position hacks)
    const injectCssHide = () => {
      if (document.getElementById(STYLE_ID)) return;
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = `
        ${SEL_HOST}, inbox-online-store-chat{
          opacity: 0 !important;
          visibility: hidden !important;
          pointer-events: none !important;
        }
      `;
      document.head.appendChild(style);
    };

    const removeCssHide = () => {
      const style = document.getElementById(STYLE_ID);
      if (style) style.remove();
    };

    // ✅ FIX: "soft open" keeps the host renderable but invisible while it boots
    const injectCssSoftOpen = () => {
      if (document.getElementById(SOFT_ID)) return;
      const style = document.createElement('style');
      style.id = SOFT_ID;
      style.textContent = `
        ${SEL_HOST}, inbox-online-store-chat{
          visibility: visible !important;
          pointer-events: auto !important;
          opacity: 0 !important;
          transition: none !important;
        }
      `;
      document.head.appendChild(style);
    };

    const removeCssSoftOpen = () => {
      const style = document.getElementById(SOFT_ID);
      if (style) style.remove();
    };

    const forceVisible = () => {
      const h = getHost();
      if (!h) return;
      h.style.setProperty('opacity', '1', 'important');
      h.style.setProperty('visibility', 'visible', 'important');
      h.style.setProperty('pointer-events', 'auto', 'important');
    };

    const restorePageScroll = () => {
      const html = document.documentElement;
      const body = document.body;

      if (html) {
        html.style.removeProperty('overflow');
        html.style.removeProperty('position');
        html.style.removeProperty('top');
        html.style.removeProperty('width');
      }
      if (body) {
        body.style.removeProperty('overflow');
        body.style.removeProperty('position');
        body.style.removeProperty('top');
        body.style.removeProperty('width');
        body.style.removeProperty('touch-action');
      }
    };

    const forceHidden = () => {
      const h = getHost();
      if (!h) return;
      h.style.setProperty('opacity', '0', 'important');
      h.style.setProperty('visibility', 'hidden', 'important');
      h.style.setProperty('pointer-events', 'none', 'important');

      restorePageScroll();
      setTimeout(restorePageScroll, 50);
      setTimeout(restorePageScroll, 150);
    };

    const clickLauncherInShadow = () => {
      const h = getHost();
      if (!h || !h.shadowRoot) return false;
      const sr = h.shadowRoot;

      const launcher =
        sr.querySelector('[part~="launcher"]') ||
        sr.querySelector('[part*="launcher" i]') ||
        sr.querySelector('[class*="launcher" i]') ||
        sr.querySelector('button[aria-label*="chat" i]') ||
        sr.querySelector('button[aria-label*="inbox" i]') ||
        sr.querySelector('button, [role="button"]') ||
        null;

      if (!launcher || typeof launcher.click !== 'function') return false;
      launcher.click();
      return true;
    };

    const clickCloseInShadow = () => {
      const h = getHost();
      if (!h || !h.shadowRoot) return false;
      const sr = h.shadowRoot;

      const closeBtn =
        sr.querySelector('[part~="close"]') ||
        sr.querySelector('[part*="close" i]') ||
        sr.querySelector('button[aria-label*="close" i]') ||
        sr.querySelector('button[aria-label*="back" i]');

      if (!closeBtn || typeof closeBtn.click !== 'function') return false;
      closeBtn.click();
      return true;
    };

    const setIsOpen = (open) => {
      const h = getHost();
      if (!h) return false;

      try {
        h.setAttribute('is-open', open ? 'true' : 'false');
      } catch {}

      try {
        if (open) {
          h.setAttribute('open', '');
          h.setAttribute('opened', '');
        } else {
          h.removeAttribute('open');
          h.removeAttribute('opened');
        }
      } catch {}

      try { h.isOpen = !!open; } catch {}
      try { h.open = !!open; } catch {}
      try { h.opened = !!open; } catch {}

      return true;
    };

    const isActuallyOpen = () => {
      const h = getHost();
      if (!h) return false;
      const v = String(h.getAttribute('is-open') || '').toLowerCase();
      if (v === 'true' || v === '') return true;
      if (h.shadowRoot && h.shadowRoot.childElementCount > 0) return true;
      return false;
    };

    window.__rxInboxClose = () => {
      const didClick = clickCloseInShadow();
      setIsOpen(false);
      removeCssSoftOpen();
      injectCssHide();
      forceHidden();
      restorePageScroll();
      setTimeout(restorePageScroll, 50);
      setTimeout(restorePageScroll, 150);
      log('Close called. clickedClose?', didClick);
      return didClick;
    };

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && window.__rxInboxClose) window.__rxInboxClose();
    });

    injectCssHide();
    forceHidden();
    setTimeout(forceHidden, 100);
    setTimeout(forceHidden, 400);
    setTimeout(forceHidden, 900);

    (() => {
      const start = performance.now();
      const MAX_MS = 6000;
      const tick = () => {
        const h = getHost();
        if (h) {
          injectCssHide();
          forceHidden();
          return;
        }
        if (performance.now() - start > MAX_MS) return;
        setTimeout(tick, 120);
      };
      tick();
    })();

    let rxHostObserved = false;
    const observeHostOpenState = () => {
      if (rxHostObserved) return;
      const h = getHost();
      if (!h) return;

      rxHostObserved = true;

      const mo = new MutationObserver(() => {
        const val = String(h.getAttribute('is-open') || '').toLowerCase();
        const isOpen = val === 'true' || val === '';

        if (!isOpen) {
          removeCssSoftOpen();
          injectCssHide();
          forceHidden();
          restorePageScroll();
          setTimeout(restorePageScroll, 50);
          setTimeout(restorePageScroll, 150);
        }
      });

      mo.observe(h, { attributes: true, attributeFilter: ['is-open', 'open', 'opened'] });
    };

    observeHostOpenState();
    setTimeout(observeHostOpenState, 250);
    setTimeout(observeHostOpenState, 900);

    let rxOpening = false;

    window.__rxInboxShowAndOpen = () => {
      if (rxOpening) return true;
      rxOpening = true;

      injectCssHide();
      injectCssSoftOpen();

      const h = getHost();
      if (h) {
        h.style.setProperty('transition', 'none', 'important');
        h.style.setProperty('visibility', 'visible', 'important');
        h.style.setProperty('pointer-events', 'auto', 'important');
        h.style.setProperty('opacity', '0', 'important');
      }

      observeHostOpenState();

      const scrollY = window.scrollY;

      const start = performance.now();
      const MAX_MS = 1400;

      let clicked = false;

      const tick = () => {
        setIsOpen(true);

        if (!clicked) {
          clicked = true;
          clickLauncherInShadow();
        }

        setTimeout(() => window.scrollTo(0, scrollY), 0);
        setTimeout(() => window.scrollTo(0, scrollY), 50);
        setTimeout(() => window.scrollTo(0, scrollY), 150);

        if (isActuallyOpen()) {
          removeCssHide();
          removeCssSoftOpen();
          forceVisible();
          rxOpening = false;
          return;
        }

        if (performance.now() - start > MAX_MS) {
          removeCssHide();
          removeCssSoftOpen();
          forceVisible();
          rxOpening = false;
          return;
        }

        setTimeout(tick, 60);
      };

      tick();
      return true;
    };
  })();

  const init = () => {
    const wrapper = document.querySelector('.sticky-add-to-cart-wrapper');
    if (!wrapper) return;

    wrapper.classList.add('is-ready');
    wrapper.classList.remove('native-atc-visible');

    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

    // ✅ state flags for the Need Help notch
    let hasSeenAtc = false;   // has the user ever reached the ATC area?
    let helpMounted = false;  // has the notch been added already?

    const createHelpNotch = () => {
      const notch = document.createElement('button');
      notch.type = 'button';
      notch.className = 'rx-help-notch';
      notch.setAttribute('aria-label', 'Need help? Open chat');
      notch.innerHTML = '<i class="rx-help-dot" aria-hidden="true"></i><span>Need help?</span>';
      return notch;
    };

    const openShopifyInbox = () => {
      if (window.__rxInboxShowAndOpen) {
        window.__rxInboxShowAndOpen();
        return true;
      }
      return false;
    };

    // ✅ Only mounts when called; we control WHEN via IntersectionObserver
    const mountHelpNotch = () => {
      if (helpMounted) return;
      if (!isMobile()) return;

      const sticky = wrapper.querySelector('.sticky-atc');
      if (!sticky) return;

      if (wrapper.querySelector('.rx-help-notch')) {
        helpMounted = true;
        return;
      }

      const notch = createHelpNotch();
      notch.addEventListener('click', () => {
        const ok = openShopifyInbox();
        if (!ok) setTimeout(openShopifyInbox, 300);
      });

      sticky.appendChild(notch);
      helpMounted = true; // ✅ permanent for this page session
    };

    // ❌ NO immediate mount here anymore – only after ATC is seen

    window.addEventListener(
      'resize',
      () => {
        if (!isMobile()) {
          // Remove notch on desktop
          wrapper.querySelectorAll('.rx-help-notch').forEach(n => n.remove());
          helpMounted = false;
          return;
        }
        // ✅ If we've already seen ATC and we're on mobile again, ensure notch exists
        if (hasSeenAtc && !helpMounted) {
          mountHelpNotch();
        }
      },
      { passive: true }
    );

    const jsonEl = document.querySelector('script[id^="StickyAtc-VariantsJson-"]');
    if (!jsonEl) return;

    let variants = [];
    let optionNames = [];
    try {
      const parsed = JSON.parse(jsonEl.textContent);

      if (Array.isArray(parsed)) {
        variants = parsed;
        optionNames = [];
      } else {
        variants = Array.isArray(parsed?.variants) ? parsed.variants : [];
        optionNames = Array.isArray(parsed?.options) ? parsed.options : [];
      }
    } catch {
      return;
    }

    if (!Array.isArray(variants) || variants.length === 0) return;

    const normName = (n) => String(n || '').trim().toLowerCase();
    const sizeIndex = optionNames.findIndex(n => normName(n) === 'size');
    const leatherIndex = optionNames.findIndex(n => normName(n) === 'leather');

    const getOptionFromVariant = (variant, idx) => {
      if (!variant || idx == null || idx < 0) return '';
      if (Array.isArray(variant.options) && idx < variant.options.length) {
        return String(variant.options[idx] ?? '').trim();
      }
      if (idx === 0) return String(variant.option1 ?? '').trim();
      if (idx === 1) return String(variant.option2 ?? '').trim();
      if (idx === 2) return String(variant.option3 ?? '').trim();
      return '';
    };

    const getSizeRawFromVariant = (variant) => {
      if (sizeIndex >= 0) return getOptionFromVariant(variant, sizeIndex);
      const o2 = getOptionFromVariant(variant, 1);
      return o2 || getOptionFromVariant(variant, 0);
    };

    const getLeatherRawFromVariant = (variant) => {
      if (leatherIndex >= 0) return getOptionFromVariant(variant, leatherIndex);
      return getOptionFromVariant(variant, 0);
    };

    const byId = new Map(variants.map(v => [String(v.id), v]));

    const moneyFormat = (window.Shopify && window.Shopify.money_format)
      ? window.Shopify.money_format
      : null;

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return (Number(cents) / 100).toFixed(2);
    };

    const priceEl = wrapper.querySelector('.sticky-atc__price-inline');
    const compareEl = wrapper.querySelector('.sticky-atc__price-compare');
    const sizeEl = wrapper.querySelector('.sticky-atc__size-line');

    const idInput =
      document.querySelector('input[data-variant-info="variant_id"][name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('input[name="id"]');

    if (!priceEl || !idInput) return;

    const stickyBtn = wrapper.querySelector('[data-sticky-atc-button]');

    const productForm =
      stickyBtn && stickyBtn.getAttribute('form')
        ? document.getElementById(stickyBtn.getAttribute('form'))
        : document.querySelector('form[action*="/cart/add"]');

    const nativeAtcBtn = productForm
      ? productForm.querySelector('button[name="add"]:not([data-sticky-atc-button])')
      : null;

    const setStickyLoading = (loading) => {
      if (!stickyBtn) return;

      stickyBtn.classList.toggle('is-loading', loading);

      if (loading) {
        stickyBtn.setAttribute('aria-busy', 'true');
        stickyBtn.setAttribute('disabled', 'disabled');
      } else {
        stickyBtn.removeAttribute('aria-busy');
        stickyBtn.removeAttribute('disabled');
      }
    };

    const syncStickyButtonState = () => {
      if (!stickyBtn || !nativeAtcBtn) return;

      const nativeLoading =
        nativeAtcBtn.dataset.loading === 'true' ||
        nativeAtcBtn.getAttribute('aria-loading') === 'true' ||
        nativeAtcBtn.getAttribute('aria-busy') === 'true' ||
        nativeAtcBtn.classList.contains('is-loading') ||
        nativeAtcBtn.classList.contains('loading') ||
        nativeAtcBtn.classList.contains('pointer-events-none');

      const nativeDisabled =
        nativeAtcBtn.disabled ||
        nativeAtcBtn.hasAttribute('disabled');

      stickyBtn.classList.toggle('is-loading', nativeLoading);

      if (nativeLoading || nativeDisabled) {
        stickyBtn.setAttribute('disabled', 'disabled');
      } else {
        stickyBtn.removeAttribute('disabled');
      }

      if (nativeLoading) {
        stickyBtn.setAttribute('aria-busy', 'true');
      } else {
        stickyBtn.removeAttribute('aria-busy');
      }
    };

    if (stickyBtn && productForm && !stickyBtn.__rxStickyMirrorBound) {
      stickyBtn.__rxStickyMirrorBound = true;

      productForm.addEventListener('submit', () => {
        setStickyLoading(true);
      });

      document.addEventListener('product:added-to-cart', () => {
        setStickyLoading(false);
        syncStickyButtonState();
      });

      window.addEventListener('pageshow', () => {
        setStickyLoading(false);
        syncStickyButtonState();
      });

      if (nativeAtcBtn && 'MutationObserver' in window) {
        const observer = new MutationObserver(syncStickyButtonState);

        observer.observe(nativeAtcBtn, {
          attributes: true,
          attributeFilter: [
            'disabled',
            'data-loading',
            'aria-loading',
            'aria-busy',
            'class'
          ]
        });

        syncStickyButtonState();
      }
    }

    const normalizeSizeToken = (raw) => {
      if (!raw) return '';
      const s = String(raw).trim();
      const m = s.match(/^\s*(XXXL|XXL|XL|L|M|S|XS|XXS)\b/i);
      return m ? m[1].toUpperCase() : s.toUpperCase();
    };

    // ✅ Sticky bar visibility + ATC observer
    const atcWatch =
      document.querySelector('form[action*="/cart/add"] button[name="add"]:not([data-sticky-atc-button])') ||
      document.getElementById('MainAtcAnchor') ||
      document.querySelector('form[action*="/cart/add"]');

    if (atcWatch) {
      const isAtcReallyVisible = () => {
        const rect = atcWatch.getBoundingClientRect();
        const stickyRect = wrapper.getBoundingClientRect();

        const stickyHeight = stickyRect.height || 90;
        const buffer = 16;

        const safeBottom = window.innerHeight - stickyHeight - buffer;

        return (
          rect.top < safeBottom &&
          rect.bottom > 0
        );
      };

      const updateAtcVisibility = () => {
      const visible = isAtcReallyVisible();

      // Do NOT hide the whole sticky bar here.
      // Only mark that the native ATC is visible.
      wrapper.classList.toggle('native-atc-visible', visible);

      if (visible) {
        hasSeenAtc = true;
        if (isMobile() && !helpMounted) {
          mountHelpNotch();
        }
      }
};

      let stickyVisibilityRaf = null;

      const requestAtcVisibilityUpdate = () => {
        if (stickyVisibilityRaf) return;

        stickyVisibilityRaf = requestAnimationFrame(() => {
          stickyVisibilityRaf = null;
          updateAtcVisibility();
        });
      };

      window.addEventListener('scroll', requestAtcVisibilityUpdate, { passive: true });
      document.addEventListener('scroll', requestAtcVisibilityUpdate, { passive: true, capture: true });

      window.addEventListener('resize', requestAtcVisibilityUpdate, { passive: true });

      // Show by default on page load.
      // Visibility check only starts once the customer scrolls/resizes.
      wrapper.classList.remove('native-atc-visible');
    }

    // ✅ Detect leather selector exists
    const hasLeatherSelector = (() => {
      const fieldsets = Array.from(document.querySelectorAll('fieldset[data-option-group]'));
      const sizeFs = fieldsets.find(fs => fs.querySelector('.rx-size-title, .rx-size-chip, .size-info')) || null;
      const visibleFieldsets = fieldsets.filter(fs => fs.offsetParent !== null);
      const candidate = visibleFieldsets.find(fs => fs !== sizeFs) || null;
      return !!candidate;
    })();

    const update = () => {
      const variant = byId.get(String(idInput.value));
      if (!variant) return;

      const priceFormatted = formatMoney(variant.price);
      if (priceEl.textContent.trim() !== priceFormatted) {
        priceEl.textContent = priceFormatted;
      }

      if (compareEl) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

        if (onSale) {
          const compareFormatted = formatMoney(variant.compare_at_price);
          compareEl.textContent = compareFormatted;
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      if (sizeEl) {
        const leatherValue = getLeatherRawFromVariant(variant);
        const sizeRaw = getSizeRawFromVariant(variant);

        let sizeDisplay = sizeRaw;
        if (hasLeatherSelector) {
          let s = sizeRaw;
          if (s) {
            const m = s.match(/^\s*(XXXL|XXL|XL|L|M|S|XS|XXS)\b/i);
            if (m) s = m[1].toUpperCase();
          }
          sizeDisplay = s;
        }

        const parts = [];
        if (!hasLeatherSelector) {
          if (sizeDisplay) parts.push(`Size: ${sizeDisplay}`);
        } else {
          if (sizeDisplay) parts.push(`Size: ${sizeDisplay}`);
          if (leatherValue) parts.push(leatherValue);
        }

        const nextText = parts.join('  •  ');
        if (nextText && sizeEl.textContent.trim() !== nextText) {
          sizeEl.textContent = nextText;
        }
      }
    };

    update();
    requestAnimationFrame(update);
    setTimeout(update, 100);

    const container =
      document.querySelector('form[action*="/cart/add"]') ||
      document;

    container.addEventListener('change', () => {
      update();
      requestAnimationFrame(update);
      setTimeout(update, 100);
    }, true);

    document.addEventListener('product:added-to-cart', update);
    document.addEventListener('product:variant-change', update);
    document.addEventListener('variant:changed', update);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();